export default __webpack_public_path__ + "static/hero-image-4-dd89e4907b109a4c5fade0fe83ddf910.jpeg";